import { CncEquipmentExt } from '../../../../shared/types/cncEquipmentExt.ts';
import { LinkButton } from '../../../components/linkButton.tsx';


interface Props {
    style?: React.CSSProperties;
    equipments: CncEquipmentExt[];
    onEditClick: (equipment: CncEquipmentExt) => void;
}

export function CncSignalsTable({
    style,
    equipments,
    onEditClick,
}: Props) {
    return (
        <table className='equipment-signals' style={{...style, tableLayout: 'fixed', width: '0px' }}>
            <colgroup>
                <col style={{ width: '200px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '100px' }} />
                <col style={{ width: '120px' }} />
                <col style={{ width: '80px' }} />
            </colgroup>
            <thead>
                <tr>
                    <th>Equipment</th>
                    <th>Program name</th>
                    <th>Interval target</th>
                    <th>Feed override</th>
                    <th>Warm up</th>
                    <th>Dry run</th>
                    <th>Parts required</th>
                    <th>Tool change signals</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {equipments?.map(equipment =>
                    <tr key={equipment.id}>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>
                            {equipment.displayName}
                        </td>
                        <td className='single-signal'>{equipment.programSignal}</td>
                        <td className='single-signal'>{equipment.intervalTargetSignal}</td>
                        <td className='single-signal'>{equipment.feedOverrideSignal}</td>
                        <td className='single-signal'>{equipment.warmUpSignal}</td>
                        <td className='single-signal'>{equipment.dryRunSignal}</td>
                        <td className='single-signal'>{equipment.partsRequiredSignal}</td>
                        <td>{equipment.toolChangeSignals?.length}</td>
                        <td>
                            <LinkButton
                                onClick={() => onEditClick(equipment)}
                                content='Edit'
                            />
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
